import { Routes, Route } from 'react-router-dom';
import { Landing } from './Landing';

export const InternalRoutes = () => {
    return (
        <Routes>
            <Route path="/" index element={<Landing/>}/>
        </Routes>
    )
}